<template>
	<div>
		<h2>{{ $t('labels.general.subscription') }}</h2>
		<spinner v-if="subscription.loading"/>
		<div v-else class="idi-table subscription">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.service') }}</div>
				<div class="idi-cell">{{ $t('labels.general.price_by_unit') }}</div>
				<div class="idi-cell">{{ $t('labels.general.units') }}</div>
				<div class="idi-cell">{{ $t('labels.general.total') }}</div>
				<div class="idi-cell">{{ $t('labels.general.payment') }}</div>
				<div class="idi-cell">{{ $t('labels.general.next_payment') }}</div>
				<div class="idi-cell">{{ $t('labels.general.auto_renew') }}</div>
			</div>
			<div class="idi-row">
				<div class="idi-cell">
					<span>{{ subscription.data.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ $t(serviceNamesTranslated.get(subscription.data.service_name)) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.data.price_unity }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.data.units }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.data.total }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ $t(paymentFrequencyTranslated.get(subscription.data.frequency_payment)) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ subscription.data.next_payment_date ? subscription.data.next_payment_date.date : '' | formatDate(vue) }}</span>
				</div>
				<div class="idi-cell">
					<span :class="subscription.data.auto_renew ? 'true' : 'false'">{{ subscription.data.auto_renew ? '✓' : 'ꭙ' }}</span>
				</div>
			</div>
		</div>
		<h2>{{ $t('labels.general.transaction') }}</h2>
		<spinner v-if="transaction.loading"/>
		<div v-else class="idi-table transaction">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
				<div class="idi-cell">{{ $t('labels.general.description') }}</div>
				<div class="idi-cell">{{ $t('labels.general.service_period') }}</div>
				<div class="idi-cell">{{ $t('labels.general.state') }}</div>
				<div class="idi-cell">{{ $t('labels.general.subtotal') }}</div>
				<div class="idi-cell">{{ $t('labels.general.total') }}</div>
			</div>
			<div class="idi-row">
				<div class="idi-cell">
					<span>{{ transaction.data.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.data.create_time | formatDate(vue) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.data.message }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.data.period_start | formatDate(vue) }} - {{ transaction.data.period_end | formatDate(vue) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.data.state }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.data.subtotal }}€ <span class="tax">(+{{ transaction.data.tax }}€ {{ $t('labels.general.tax') }})</span></span>
				</div>
				<div class="idi-cell">
					<span>{{ transaction.data.total }}€</span>
				</div>
			</div>
		</div>
		<h2>{{ $t('labels.general.account_movement') }}</h2>
		<spinner v-if="transaction.loading || movement.loading"/>
		<div v-else class="idi-table movement">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.message') }}</div>
				<div class="idi-cell">{{ $t('labels.general.amount') }}</div>
				<div class="idi-cell">{{ $t('labels.general.operation') }}</div>
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row">
				<div class="idi-cell">
					<span>{{ movement.data.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.data.message }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.data.value }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.data.operation }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ movement.data.create_time | formatDate(vue) }}</span>
				</div>
				<div class="idi-cell">
					<router-link
						:to="{ name: 'UserProfileBudgetAccountMovements',
						params: { user_uid } }"
						class="btn btn-round btn-small">{{ $t('labels.general.view') }}</router-link>
				</div>
			</div>
		</div>
		<h2>{{ $t('labels.general.logs') }}</h2>
		<spinner v-if="logs.loading"/>
		<div v-else class="idi-table logs">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.logs') }}</div>
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
			</div>
			<div class="idi-row-empty" v-if="!logs.data.length">
				<div class="idi-cell">{{ $t('labels.general.empty') }}</div>
			</div>
			<div class="idi-row" v-for="log in logs.data" :key="log.id">
				<div class="idi-cell">
					<span>{{ log.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ log.message }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ log.create_time | formatDate(vue) }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import ApiCollection from '@/classes/api/ApiCollection'
export default {
	props: [
		'user_uid',
		'subscription_id',
		'subscription_data',
		'transaction_id',
		'transaction_data'
	],
	data () {
		return {
			vue: this,
			name: 'transaction view',
			services: new ApiCollection(),
			subscription: new ApiObject(),
			transaction: new ApiObject(),
			movement: new ApiObject(),
			logs: new ApiCollection(),
			paymentFrequencyTranslated: new Map([ [ -2, 'labels.general.yearly' ], [ -1, 'labels.general.monthly' ], [ 0, 'labels.general.daily' ] ]),
			serviceNamesTranslated: new Map([ [ 'Rent watches', 'labels.general.rent_watches' ], [ 'Seats', 'labels.general.seats' ] ]),
		}
	},
	methods: {
		getServicesData () {
			this.services.loading = true
			return this.$api.subscriptions.services.getAll(this)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.services.getAll OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.services.getAll ERROR', error)()
					this.services.error = error
				}).finally(() => {
					this.services.loading = false
				})
		},
		getSubscriptionData () {
			this.subscription.loading = true
			return this.$api.subscriptions.getById(this, this.user_uid, this.subscription_id)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.getById OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.getById ERROR', error)()
					this.subscription.error = error
				}).finally(() => {
					this.subscription.loading = false
				})
		},
		getSubscription () {
			Promise.all([this.getServicesData(), this.getSubscriptionData()])
				.then(([services, subscription]) => {
					const map = new Map()
					this.services.data = services
					this.services.data.forEach(ele => { map.set(ele.id, ele.name) })
					const service_name = map.get(subscription.service_id) || ''
					this.subscription.data = { ...subscription, service_name }
				})
		},
		getTransaction () {
			this.transaction.loading = true
			this.$api.subscriptions.transactions.getById(this, this.user_uid, this.subscription_id, this.transaction_id)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.transactions.getById OK', response)()
					this.transaction.data = response.body
					if (this.transaction.data.operation_id) this.getMovement()
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.transactions.getById ERROR', error)()
					this.transaction.error = error
				}).finally(() => {
					this.transaction.loading = false
				})
		},
		getMovement () {
			this.movement.loading = true
			this.$api.subscriptions.operations.getById(this, this.user_uid, this.transaction.data.operation_id)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.operations.getById OK', response)()
					this.movement.data = response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.operations.getById ERROR', error)()
					this.movement.error = error
				}).finally(() => {
					this.movement.loading = false
				})
		},
		getLogs () {
			this.logs.loading = true
			this.$api.subscriptions.transactions.getLogsById(this, this.user_uid, this.subscription_id, this.transaction_id)
				.then(response => {
					this.$log.info(this.name, 'subscriptions.transactions.getLogsById OK', response)()
					this.logs.data = response.body
				}).catch(error => {
					this.$log.error(this.name, 'subscriptions.transactions.getLogsById ERROR', error)()
					this.logs.error = error
				}).finally(() => {
					this.logs.loading = false
				})
		}
	},
	mounted () {
		this.subscription_data ? this.subscription.data = this.subscription_data : this.getSubscription()
		this.transaction_data ? (() => { this.transaction.data = this.transaction_data; this.getMovement() })() : this.getTransaction()
		this.getLogs()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/SubscriptionTransactionView.vue